/**
 * A headline figure with its parts shown underneath.
 *
 * Exists because the alternative was one card per number, and that is how this
 * page reached twenty cards with duplicates in it. "Total money processed" is
 * only meaningful next to its in/out split, so they belong in one card rather
 * than three competing for the same glance.
 */
function SplitCard({ title, total, rows = [], note, className = "" }) {
  return (
    <div
      className={`p-5 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 ${className}`}
    >
      <p className="text-sm text-gray-500 dark:text-gray-400">{title}</p>
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-0.5">
        {total}
      </h2>

      <div className="mt-4 divide-y divide-gray-100 dark:divide-gray-700">
        {rows.map((r) => (
          <div
            key={r.label}
            className="flex items-baseline justify-between py-2 first:pt-0 last:pb-0"
          >
            <div className="min-w-0 pr-3">
              <p className="text-sm font-medium text-gray-700 dark:text-gray-200">
                {r.label}
              </p>
              {r.sub && (
                <p className="text-xs text-gray-400 truncate">{r.sub}</p>
              )}
            </div>
            <p
              className={`text-base font-semibold whitespace-nowrap ${
                r.tone || "text-gray-900 dark:text-white"
              }`}
            >
              {r.value}
            </p>
          </div>
        ))}
      </div>

      {note && (
        <p className="text-xs text-gray-400 mt-3 leading-snug">{note}</p>
      )}
    </div>
  );
}

export default SplitCard;
